import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { NavBar } from './components/NavBar';
import { NetBG } from './components/NetBG';
import { About } from './components/About';
import { EducationWork } from './components/EducationWork';
import { Projects } from './components/Projects';
import { useTooltipSuppression } from './hooks/useTooltipSuppression';

function App() {
    useTooltipSuppression();

    return (
        <div className="App">
            <NavBar />
            <NetBG />
            <About />
            <EducationWork />
            <Projects />
        </div>
    );
}

export default App;
